import {
  featureProperties,
  firestore as firestoreTypes,
} from "@foresting-tomorrow/api_types_firestore";
import { z } from "zod";

// --- From Firestore to GeoJson --- //
export interface FirestoreFeatureProps extends FirestoreFeatureProperties {
  coordinates: FirestoreCoordinates;
}

export type FirestoreExternalWMSDataLayer = z.infer<typeof firestoreTypes.wmsDataLayer>;
export type FirestoreExtendedWMSOptions = z.infer<typeof firestoreTypes.wmsLayerOptions>;
export type FirestoreLayerLegend = z.infer<typeof firestoreTypes.legend>;

export type FirestoreEsriMapServerLayer = z.infer<typeof firestoreTypes.esriMapServerLayer>;

export type FirestoreRESTLayer = z.infer<typeof firestoreTypes.restDataLayer>;

export type FirestoreCoordinates =
  | LatLngProps
  | LatLngProps[]
  | FirestorePointCoordinatesProps
  | FirestoreMultiPointCoordinatesProps
  | FirestoreLineCoordinatesProps
  | FirestoreMultiLineCoordinatesProps
  | FirestorePolygonCoordinatesProps
  | FirestoreMultiPolygonCoordinatesProps;

export type FirestoreFeatureProperties = z.infer<typeof featureProperties.geojsonFeatureProperties>;

export type FeatureStyleObject = z.infer<typeof featureProperties.featureStyleObject>;

export type FirestoreStandProps = z.infer<typeof featureProperties.stand>;
export type FirestoreUpdateStandProps = z.infer<typeof featureProperties.updateStandData>;

export type FirestoreThinningProps = z.infer<typeof featureProperties.thinning>;

export type FirestoreActivityProps = z.infer<typeof firestoreTypes.activity> & {
  volume?: number;
};

export const certificationTagsOptions = firestoreTypes.inventoryCertificationEntityTags.options;

export type ActivityBiomassScreening = FirestoreActivityProps["biomassScreening"];

export type ActivityType = z.infer<typeof firestoreTypes.activityType>;

export type ActivityResponsible = z.infer<typeof firestoreTypes.activityResponsible>;

export type SaveThinningProps = Omit<FirestoreThinningProps, "creationDate" | "lastModifiedDate">;

export type FirestoreNoteProps = z.infer<typeof firestoreTypes.mapNote>;

// --- Coordinate converter props --- //
// Point
export interface FirestorePointCoordinatesProps {
  coordinates: LatLngProps;
}
// MultiPoint
export interface FirestoreMultiPointCoordinatesProps {
  coordinates: LatLngProps[];
}
// LineString
export interface FirestoreLineCoordinatesProps {
  coordinates: LatLngProps[];
}
// MultiLineString
export interface FirestoreMultiLineCoordinatesProps {
  [key: string]: LatLngProps[];
}

// Polygon
export interface FirestorePolygonCoordinatesProps {
  perimeter: LatLngProps[];
  holes: FirestoreHoleProps;
}
// MultiPolygon
export interface FirestoreMultiPolygonCoordinatesProps {
  [key: string]: FirestorePolygonCoordinatesProps;
}
// Helper types
interface FirestoreHoleProps {
  [key: string]: LatLngProps[];
}

export interface LatLngProps {
  lat: number;
  lng: number;
}

// --- From Leaflet to Firestore --- //
export interface LeafletFeatureToFirestoreProps {
  feature: any;
  data?: any;
}
